import React, { useState, useEffect } from 'react';
import { Link,useNavigate} from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import {API_BASE_URL} from "../../apiConfig.jsx";
import axios from 'axios';
import {cleanStr,cleanPass} from '../../comfunc.js';
import {strEncode,strDecode} from '../../encrpt.js';
import DataTable from 'react-data-table-component';
import TableSearch from "./TableSearch.js";
import DatePicker from "react-datepicker";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import Select2 from "../../Select2/select2.js";
import moment from 'moment';



function Finance() {
    // Initialize directly from localStorage so it's not null on first render
	  const initialUser = (() => {
		const storedUser = localStorage.getItem("user");
		return storedUser ? JSON.parse(storedUser) : null;
	  })();
	
	  const [userData, setUserData] = useState(initialUser);
	  const navigate = useNavigate();
	
	  useEffect(() => {
		const authToken = localStorage.getItem("authToken");
	
		if (authToken) {
		  // Keep state in sync if user data changes
		  const storedUser = localStorage.getItem("user");
		  if (storedUser) {
			try {
			  setUserData(JSON.parse(storedUser));
			} catch (err) {
			  console.error("Failed to parse stored user:", err);
			  localStorage.removeItem("user");
			  navigate("/"); // redirect if corrupted
			}
		  }
		} else {
		  // No token → clear session and redirect
		  localStorage.removeItem("user");
		  navigate("/"); // adjust path to your login route
		}
	  }, [navigate]);

	const userid  = JSON.parse(localStorage.getItem("userId"))
	const [formData, setFormData] = useState({
		n_participants_id: "",
		c_participants_name : "",
		n_mobile_num: "",
		n_area: "",
		n_approval: "",
		c_remarks: "",
		n_delivery: "",
		n_deposit_1 : "",
		n_deposit_2 :"",
		n_print :"",
		n_unified_card :"",
		n_citizen_id :"",
		n_fixed_deposit :"",
		n_second_deposit :"",
		c_applied_arabic :""
	  });
	  
	 const [errors, setErrors] = useState({});
     const [participants, setParticipantsList] = useState([]);
	  const [arealist, setAreaList] = useState([]);
	 const [tfstatus, setTrueFalseList] = useState([]);
	 const [approvalstatus, setApprovalStatuslist] = useState([]);
	 const [columns, setColumns] = useState([]);
	 const [tabledata, settableData] = useState([]);	 	
	 const [selectedUser, setSelectedUser] = useState(null);
	 const [selectedparticipant, setSelectedParticipant] = useState([]);
     const [editMode, setEditMode] = useState(false);
     const [activeTab, setActiveTab] = useState("default-tab-1"); // Tracks active tab
  useEffect(() => {
	// Switch to "Ajouter un nouvel utilisateur" tab if edit mode is enabled
	if (editMode) {
	  setActiveTab("default-tab-2");
	//setEditMode(false)
	} else {
	  setActiveTab("default-tab-1");
	}
  }, [editMode]);
  
  useEffect(() => {
	/* axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('v_pmis_participants_evaluated')},{ headers: { 'Content-Type': 'application/json' } }) 
    	.then( (res) => {
	    setParticipantsList(res.data);
	    }).catch( (error) => { console.log(error); }); */

		 axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_participants_registration'),cols:strEncode('*'),whrc : userData.usertype === 1 ? "" : strEncode('n_org_id = "'+userData.org+'"') },{ headers: { 'Content-Type': 'application/json' } }) 
    	.then( (res) => {
	    setParticipantsList(res.data);
	    }).catch( (error) => { console.log(error); }); 
	

     axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_area_mst')},{ headers: { 'Content-Type': 'application/json' } }) 
	.then( (res) => {
		setAreaList(res.data);
	  }).catch( (error) => { console.log(error); });

	  axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_approval_status_mst')},{ headers: { 'Content-Type': 'application/json' } }) 
	.then( (res) => {
		setApprovalStatuslist(res.data);
	  }).catch( (error) => { console.log(error); });

	   axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_true_false_mst')},{ headers: { 'Content-Type': 'application/json' } }) 
	.then( (res) => {
		setTrueFalseList(res.data);
	  }).catch( (error) => { console.log(error); });

	  axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('v_pmis_individual_finance'),cols:strEncode('*'),whrc :  userData?.usertype > 0 ? "": strEncode('n_user_id = "'+userid+'"') },{ headers: { 'Content-Type': 'application/json' } }) 
				  .then( (res) => {					
					if (!res.data || !res.data || res.data.length === 0) {
						console.warn("Warning: API returned an empty or undefined response.");
						setColumns([]); // Reset columns
						settableData([]); // Reset table data
						return;
					}
					const columnKeys = Object.keys(res.data[0]);
					
					const formattedColumns = columnKeys.map((key) => ({
						name: key.charAt(0).toUpperCase() + key.slice(1),
						selector: row => row[key],
						sortable: true,
						cell: row => row[key] // Show normal column data
					  }));

					  formattedColumns.push({
						name: "Actions",
						cell: (row) => (
							<div>
						  <button className="btn btn-warning btn-sm" onClick={() => handleEdit(row)}>
						  تعديل
						  </button>
						   </div>
						),
					  });
					//console.log("columnKeys",columnKeys)
					setColumns(formattedColumns);
                    settableData(res.data);	

				  }).catch(error => {
					console.error("API Error:", error);
				  });
  }, []);
	
const tabActive = async (user) => {
	setFormData({
	n_participants_id: "",
		c_participants_name : "",
		n_mobile_num: "",
		n_area: "",
		n_approval: "",
		c_remarks: "",
		n_delivery: "",
		n_deposit_1 : "",
		n_deposit_2 :"",
		n_print :"",
		n_unified_card :"",
		n_citizen_id :"",
		n_fixed_deposit :"",
		n_second_deposit :"",
		c_applied_arabic :""
	  });
  
	 setEditMode(false);
	 setSelectedUser(null);
}

  const handleEdit = async (user) => {
	//console.log("user.id",user.id)
	setSelectedUser(user);
	try {
	  const response = await axios.post(`${API_BASE_URL}/api/custom/selectall`, {
		t: strEncode('pmis_individual_finance'),
		cols : 	strEncode('*'),	
		whrc : strEncode('id = '+user.id+''),
	  }, { headers: { 'Content-Type': 'application/json' } });
  
	 setFormData({
		id : response.data[0].id,
	    n_participants_id: response.data[0].n_participants_id,
		c_participants_name : response.data[0].c_participants_name,
		n_mobile_num: response.data[0].n_mobile_num,
		n_area: response.data[0].n_area,
		n_approval: response.data[0].n_approval,
		c_remarks: response.data[0].c_remarks,
		n_delivery: response.data[0].n_delivery,
		n_deposit_1 : response.data[0].n_deposit_1,
		n_deposit_2 :response.data[0].n_deposit_2,
		n_print :response.data[0].n_print,
		n_unified_card :response.data[0].n_unified_card,
		n_citizen_id :response.data[0].n_citizen_id,
		n_fixed_deposit :response.data[0].n_fixed_deposit,
		n_second_deposit :response.data[0].n_second_deposit,
		c_applied_arabic :response.data[0].c_applied_arabic
	  });

	} catch (error) {
	  console.error("Error fetching user data:", error);
	}
	setEditMode(true);
	setActiveTab("default-tab-2");
  };
  
   // console.log("usertyoe",usertype)
	  const userstatus = [
		{ id: 0, c_name: "Actif" },
		{ id: 1, c_name: "Inactif" },
	  ];

	  const validateEmail = (email) => {
		const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		return emailRegex.test(email);
	  };
	
	  const validatePassword = (password) => {
		return {
		  length: password.length >= 12,
		  uppercase: /[A-Z]/.test(password),
		  number: /\d/.test(password),
		  specialChar: /[~_!@#^()-+|.,]/.test(password),
		  restrictedChars: !/[&\/\\$%'"`=:;*?<>{}]/.test(password),
		};
	  };
	 
	  	const handleChangeDates = (name, date) => {
		if (!name || !date) return;
	  
		const formattedDate = date ? moment(date).format('YYYY-MM-DD') : '';
		//const change = { [name]: formattedDate };
	  
	   setFormData((prevData) => ({
				...prevData,
				[name]: formattedDate, // Keep existing password if blank
			}));
		//console.log("Date change:", change);
	  };
	


	 /* const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	
		// Validation Logic
		let newErrors = { ...errors };
	
		if (!value) {
		  newErrors[name] = "This field is required.";
		} else {
		  delete newErrors[name];
		}
	
		if (name === "c_email" && !validateEmail(value)) {
		  newErrors[name] = "Invalid email format.";
		}
	
		if (name === "c_password" ) {
		  const validations = validatePassword(value);
		  if (!validations.length) newErrors[name] = "Password must be at least 12 characters.";
		  if (!validations.uppercase) newErrors[name] = "Password must contain at least one uppercase letter.";
		  if (!validations.number) newErrors[name] = "Password must contain at least one number.";
		  if (!validations.specialChar) newErrors[name] = "Password must contain at least one special character.";
		  if (!validations.restrictedChars) newErrors[name] = "Password contains restricted characters.";
		}
	
		setErrors(newErrors);
	  }; */
	
	  const handlevalidateNumber = (e) => {
  const { name, value } = e.target;
  let numericValue = Number(value);

  // Clamp value between 0 and 10
  if (numericValue < 0) numericValue = 0;
  if (numericValue > 10) numericValue = 10;

  setFormData((prev) => ({
    ...prev,
    [name]: numericValue,
  }));
};

	  const handleChange = (e) => {
		const { name, value } = e.target;
		
		setFormData((prevData) => ({
			...prevData,
			[name]: name === "c_password" && !value ? "" : value, // Keep existing password if blank
		}));
	
		// Validation Logic
		let newErrors = { ...errors };
	
		if (!value) {
			newErrors[name] = "This field is required.";
		} else {
			delete newErrors[name];
		}
	
		if (name === "c_email" && !validateEmail(value)) {
			newErrors[name] = "Invalid email format.";
		}
	
		if (name === "c_password" && value) { // Only validate if password is entered
			const validations = validatePassword(value);
			if (!validations.length) newErrors[name] = "Password must be at least 12 characters.";
			if (!validations.uppercase) newErrors[name] = "Password must contain at least one uppercase letter.";
			if (!validations.number) newErrors[name] = "Password must contain at least one number.";
			if (!validations.specialChar) newErrors[name] = "Password must contain at least one special character.";
			if (!validations.restrictedChars) newErrors[name] = "Password contains restricted characters.";
		}
	
		setErrors(newErrors);
	};

	 
	  const handleChangeparticipants = (e) => {
		console.log("we are here")
		const { name, value } = e.target;
		setFormData((prevData) => ({
			...prevData,
			[name]: value, // Keep existing password if blank
		}));

         axios.post(`${API_BASE_URL}/api/custom/selectall`,
			 { t: strEncode('v_pmis_participants_registration_display'),cols:strEncode('*'),whrc:strEncode('id = "'+e.target.value+'"') },
			 { headers: { 'Content-Type': 'application/json' } }) 
				  .then( (res) => {					
					var data  = res.data
					setSelectedParticipant(data);
					}).catch(error => {
					console.error("API Error:", error);
				  });
	};
	
	  const handleSubmit = async (e) => {
		e.preventDefault();
	   
		let newErrors = {};
		
		if (!editMode) {
		// If there are validation errors, stop submission
		if (Object.keys(newErrors).length > 0) {
		  setErrors(newErrors);
		  return;
		}
	}
		console.log("formdata",formData)
		try {
		  const payload = {
				data: {
					...formData,
					n_user_id: userData?.id
				}
				};
		  var response;
		  if (!editMode) {
			response = await axios.post(`${API_BASE_URL}/api/indfinance/create`, payload);
			alert("تم حفظ البيانات بنجاح!");
			setEditMode(false);
			setSelectedUser(null);
			window.location.reload(); // Refresh DataTable
		  } else {
			response = await axios.put(`${API_BASE_URL}/api/indfinance/update`, { data: formData });
			alert("تم تحديث البيانات بنجاح!");
			setEditMode(false);
			setSelectedUser(null);
			window.location.reload(); // Refresh DataTable
		  }
		   // Reset formData state
		   setFormData({
		n_participants_id: "",
		c_participants_name : "",
		n_mobile_num: "",
		n_area: "",
		n_approval: "",
		c_remarks: "",
		n_delivery: "",
		n_deposit_1 : "",
		n_deposit_2 :"",
		n_print :"",
		n_unified_card :"",
		n_citizen_id :"",
		n_fixed_deposit :"",
		n_second_deposit :"",
		c_applied_arabic :""	
		  });
		} catch (error) {
		  console.error("Error saving data:", error);
		}
	  };
 

	     const exportData = (type) => {
		 const ws = XLSX.utils.json_to_sheet(tabledata);
		 const wb = XLSX.utils.book_new();
		 XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
	
		 if (type === "csv") {
		  XLSX.writeFile(wb, "data_export.csv");
		} else {
		  XLSX.writeFile(wb, "data_export.xlsx");
		}
	  };
	
	return (
		<div>
			<ol className="breadcrumb float-xl-end">
				<li className="breadcrumb-item"><Link to="/page-option/blank">الصفحة الرئيسية</Link></li>
				<li className="breadcrumb-item"><Link to="/page-option/blank">الإدارة</Link></li>
				<li className="breadcrumb-item active">Individual Finance</li>
			</ol>
			<h1 className="page-header">الإدارة <small>إنشاء مستخدمين هنا</small></h1>
			<Panel>
				<PanelHeader>إنشاء مستخدمين هنا</PanelHeader>
				<PanelBody>
				<div className="row">
				<div className="col-xl-12">
				<ul className="nav nav-pills">
        <li className="nav-item">
          <a
            href="#default-tab-1"
            data-bs-toggle="tab"
            className={`nav-link ${activeTab === "default-tab-1" ? "active" : ""}`}
            onClick={() => setActiveTab("default-tab-1")}
          >
			 <span className="d-sm-block d-none">قائمة</span>
           
          </a>
        </li>
        <li className="nav-item">
          <a
            href="#default-tab-2"
            data-bs-toggle="tab"
            className={`nav-link ${activeTab === "default-tab-2" ? "active" : ""}`}
            onClick={() => tabActive("default-tab-2")}>
            <span className="d-sm-block d-none">إضافة التمويل الفردي</span>
          </a>
        </li>
      </ul>
					<div className="tab-content panel rounded-0 p-3 m-0">
					<div className={`tab-pane fade ${activeTab === "default-tab-1" ? "active show" : ""}`} id="default-tab-1">
						<button onClick={() => exportData("xlsx")} className="btn btn-success">
								تصدير إلى إكسل
								</button>
							<TableSearch
									title="قائمة التمويل الفردي"
									columns={columns}
									data={tabledata}
									pagination
									highlightOnHover
									
								/>

								
						</div>
						<div className={`tab-pane fade ${activeTab === "default-tab-2" ? "active show" : ""}`} id="default-tab-2">
							<form method="post" onSubmit={handleSubmit}>
									<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">حدد المشارك</label>
									<div className="col-md-9">
										 <Select2 name="n_participants_id"  value={String(formData.n_participants_id || '')} 
										  onChange={handleChangeparticipants.bind(this)} style={{ width: "100%" }}>
											<option value=''> -- Select -- </option>
											{participants.map(option => {
											return <option value={String(option.id)} key={option.id} >{option.c_name}</option>
											})}
										 </Select2>								
											{errors.n_participants_id && <span style={{ color: "red" }}>{errors.n_participants_id}</span>}
									</div>
								</div>

								<div>
									{selectedparticipant.map((option) => (
										<table style={{background:"#cecece",borderRadius:"5px"}} className="table table-responsive table-bordered table-striped">
											<tr><td>اسم</td><td>{option.c_name}</td></tr>
											<tr><td>هاتف</td><td>{option.n_phone_no}</td></tr>
											<tr><td>جنس</td><td>{option.n_currency}</td></tr>
										</table>
										))}
								</div>

                                 <div className="row mb-15px" key="n_mobile_num">
									<label className="form-label col-form-label col-md-3">رقم الهاتف المحمول</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="number"
										name= "n_mobile_num"
										value={formData.n_mobile_num}
										onChange={handleChange}
										/>
                                     {errors.n_mobile_num && <span style={{ color: "red" }}>{errors.n_mobile_num}</span>}
									</div>
									</div>
                               

								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">حدد المنطقة</label>
									<div className="col-md-9">
									<select name="n_area" className="form-select" onChange={handleChange} value={formData.n_area}>
										<option value="">يختار</option>
										{arealist.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_area && <span style={{ color: "red" }}>{errors.n_area}</span>}
									</div>
								</div>

                               <div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">الحالة</label>
									<div className="col-md-9">
									<select name="n_approval" className="form-select" onChange={handleChange} value={formData.n_approval}>
										<option value="">يختار</option>
										{approvalstatus.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_approval && <span style={{ color: "red" }}>{errors.n_approval}</span>}
									</div>
								</div>

                             <div className="row mb-15px" key="c_remarks">
								<label className="form-label col-form-label col-md-3">ملاحظات</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="text"
										name= "c_remarks"
										value={formData.c_remarks}
										onChange={handleChange}
										/>
                                     {errors.c_remarks && <span style={{ color: "red" }}>{errors.c_remarks}</span>}
									</div>
									</div>

                                     <div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">التسليم</label>
									<div className="col-md-9">
									<select name="n_delivery" className="form-select" onChange={handleChange} value={formData.n_delivery}>
										<option value="">يختار</option>
										{tfstatus.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_delivery && <span style={{ color: "red" }}>{errors.n_delivery}</span>}
									</div>
								</div>
  
                                   <div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">الإيداع 1</label>
									<div className="col-md-9">
									<select name="n_deposit_1" className="form-select" onChange={handleChange} value={formData.n_deposit_1}>
										<option value="">يختار</option>
										{tfstatus.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_deposit_1 && <span style={{ color: "red" }}>{errors.n_deposit_1}</span>}
									</div>
								</div>

								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">الإيداع 2</label>
									<div className="col-md-9">
									<select name="n_deposit_2" className="form-select" onChange={handleChange} value={formData.n_deposit_2}>
										<option value="">يختار</option>
										{tfstatus.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_deposit_2 && <span style={{ color: "red" }}>{errors.n_deposit_2}</span>}
									</div>
								</div>

								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">مطبعة</label>
									<div className="col-md-9">
									<select name="n_print" className="form-select" onChange={handleChange} value={formData.n_print}>
										<option value="">يختار</option>
										{tfstatus.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_print && <span style={{ color: "red" }}>{errors.n_print}</span>}
									</div>
								</div>

									<div className="row mb-15px" key="n_unified_card">
									<label className="form-label col-form-label col-md-3">البطاقة الموحدة</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="number"
										name= "n_unified_card"
										value={formData.n_unified_card}
										onChange={handleChange}
										/>
                                     {errors.n_unified_card && <span style={{ color: "red" }}>{errors.n_unified_card}</span>}
									</div>
									</div>
                                       
									<div className="row mb-15px" key="n_citizen_id">
									<label className="form-label col-form-label col-md-3">معرف مواطن النظام</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="text"
										name= "n_citizen_id"
										value={formData.n_citizen_id}
										onChange={handleChange}
										/>
                                     {errors.n_citizen_id && <span style={{ color: "red" }}>{errors.n_citizen_id}</span>}
									</div>
									</div>

									<div className="row mb-15px" key="n_fixed_deposit">
									<label className="form-label col-form-label col-md-3">مبلغ الإيداع الأول</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="number"
										name= "n_fixed_deposit"
										value={formData.n_fixed_deposit}
										onChange={handleChange}
										/>
                                     {errors.n_fixed_deposit && <span style={{ color: "red" }}>{errors.n_fixed_deposit}</span>}
									</div>
									</div>


									<div className="row mb-15px" key="n_second_deposit">
									<label className="form-label col-form-label col-md-3">مبلغ الإيداع الثاني</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="number"
										name= "n_second_deposit"
										value={formData.n_second_deposit}
										onChange={handleChange}
										/>
                                     {errors.n_second_deposit && <span style={{ color: "red" }}>{errors.n_second_deposit}</span>}
									</div>
									</div>

								<div className="row mb-15px" key="c_applied_arabic">
								<label className="form-label col-form-label col-md-3">العربية التطبيقية</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="text"
										name= "c_applied_arabic"
										value={formData.c_applied_arabic}
										onChange={handleChange}
										/>
                                     {errors.c_applied_arabic && <span style={{ color: "red" }}>{errors.c_applied_arabic}</span>}
									</div>
									</div>


                                {!editMode ?
								<button type="submit"  className="btn btn-success w-100px">يحفظ</button>
								:
								<button type="submit" className="btn btn-success w-100px">تحديث</button> }
								</form>
						</div>
						
					</div>
					</div>
					
					</div>
				</PanelBody>
			</Panel>
		
		</div>
	)
}

export default Finance;